export default __webpack_public_path__ + "static/16_35-22d775e424e5167c607c0ff6592c3bd7.png";